import { Component } from "@angular/core";
import { UsuarioService } from "src/app/core/services/usuario-service";
import { InitProvider } from "src/app/core/services/init-provider";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfiguracoesForm } from "src/app/core/entities/configuracoesForms";
import Swal from "sweetalert2";
import { ToastrService } from "ngx-toastr";
import {
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
declare var $: any;
import "@angular/localize/init";
@Component({
  selector: "app-page-novo-representante",
  templateUrl: "./page-novo-representante.component.html",
  styleUrls: ["./page-novo-representante.component.css"],
})
export class PageNovoRepresentanteComponent {
  userDetails: any = {
    cidades: {}
  }
  list = 0;
  filter: boolean = true;
  nome: string = "";
  representantes: any[] = [];
  clientes: any[] = [];
  edit: boolean = false;
  selectedRepresentante: any = {};
  selectedCliente: any = {};
  revisaCadastro: boolean;
  pageable: boolean = true;
  aprovaCliente: any = {}
  pageNumber = 1;
  riskList: string[] = ["A", "B", "C", "D", "E"];
  public toastService: ToastrService;
  public form: FormGroup;
  public formCliente: FormGroup;
  public aprovaId;
  public error: boolean = false;
  totalPages;
  totalElements;
  constructor(
    public usuarioService: UsuarioService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public initProvider: InitProvider,
    toastService: ToastrService
  ) {
    this.toastService = toastService;
    this.aprovaCliente = ConfiguracoesForm.aprovaCliente
    this.form = this.formBuilder.group({
      nome: ["", [Validators.required]],
      documento: ["", [Validators.required, Validators.email]],
      status: ["", [Validators.required]],
    });
    this.formCliente = this.formBuilder.group({
      limiteCredito: [null, this.aprovaCliente.limiteCredito.required ? [Validators.required] : []],
      criaUsuario: [false, [Validators.required]],
      risco: ["", this.aprovaCliente.risco.required ? [Validators.required] : []],
    });
  }

  pageChangedClients(e) {
    if (this.pageNumber !== e.page) {
      this.pageNumber = e.page;
      this.getClientes();
    }
  }
  pageChangedReps(e) {
    if (this.pageNumber !== e.page) {
      this.pageNumber = e.page;
      this.getRepresentantes();
    }
  }

  setPage(value) {
    this.list = value;
    this.filter = true;
    this.pageNumber = 1;
    if (value === 2) {
      this.getRepresentantes();
    } else if (value === 1) {
      this.getClientes();
    }
  }
  change(value) {
    this.form.controls.status.setValue(value);
  }
  abrirCadastro() {
    this.edit = false;
    this.filter = false;
  }

  editarCadastro(id) {
    this.usuarioService.getRepresentante(
      id,
      (res) => {
        this.selectedRepresentante = res[0];
        this.edit = true;
        this.filter = false;
      },
      (res) => console.log(res)
    );
  }

  editarCadastroCliente(id) {
    this.usuarioService.getCliente(
      id,
      (res) => {
        this.selectedCliente = res[0];
        this.edit = true;
        this.filter = false;
      },
      (res) => console.log(res)
    );
  }

  getRepresentantes(filtra = false) {
    if (filtra) {
      this.pageNumber = 1;
    }
    this.usuarioService.listaRepresentante(
      { ...this.form.value, page: this.pageNumber - 1 },
      this.callback.bind(this),
      this.callbackError.bind(this)
    );
  }

  getClientes(filtra = false) {
    if (filtra) {
      this.pageNumber = 1;
    }
    this.usuarioService.listaCliente(
      { ...this.form.value, page: this.pageNumber - 1 },
      this.callback.bind(this),
      this.callbackErrorCliente.bind(this)
    );
  }

  callback(resp) {
    if (this.list === 2) {
      if (resp.length === 0) {
        this.toastService.info($localize`Representante`, $localize`Nenhum registro encontrado`, {
          timeOut: 4000,
        });
      } else {
      }
      this.representantes = resp;
      this.totalPages = resp[0].paginas;
      this.totalElements = resp[0].total_elementos;
    } else if (this.list == 1) {
      if (resp.length === 0) {
        this.toastService.info($localize`Cliente`, $localize`Nenhum registro encontrado`, {
          timeOut: 4000,
        });
      }
      this.clientes = resp.clientes;
      this.totalPages = resp.paginas;
      this.totalElements = resp.total_elementos;
    }
  }
  callbackError(resp) {
    if (resp.status && resp.status === 403) {
      this.router.navigate(['/login']).then(() => {
        window.location.reload();
      });
      this.toastService.warning($localize`Usuario não autenticado`, $localize`Representante`, {
        positionClass: "toast-bottom-left",
      })
    } else {
      Swal.fire(
        $localize`Representante`,
        $localize`Algo deu errado. Tente novamente mais tarde`,
        "warning"
      );
    }
  }

  callbackErrorCliente(resp) {
    if (resp.status === 403) {
      this.router.navigate(['/login']).then(() => {
        window.location.reload();
      });
      this.toastService.warning($localize`Usuario não autenticado`, $localize`Cliente`, {
        positionClass: "toast-bottom-left",
      })
    } else {
      Swal.fire(
        $localize`Cliente`,
        $localize`Algo deu errado. Tente novamente mais tarde`,
        "warning"
      );
    }
  }

  callbackAprove(resp) {
    Swal.fire($localize`Representante`, $localize`Aprovado com sucesso!`, "success");
    this.getRepresentantes();
  }
  callbackReprove(resp) {
    Swal.fire($localize`Representante`, $localize`Recusado com sucesso!`, "success");
    this.getRepresentantes();
  }

  callbackAproveClient(resp) {
    this.formCliente.controls.limiteCredito.setValue(null);
    this.formCliente.controls.criaUsuario.setValue(false);
    this.formCliente.controls.risco.setValue("");
    Swal.fire($localize`Cliente`, $localize`Aprovado com sucesso!`, "success");
    this.getClientes();
  }
  callbackReproveClient(resp) {
    this.formCliente.controls.limiteCredito.setValue(null);
    this.formCliente.controls.criaUsuario.setValue(false);
    this.formCliente.controls.risco.setValue("");
    Swal.fire($localize`Cliente`, $localize`Recusado com sucesso!`, "success");
    this.getClientes();
  }

  selectaprovar(id, nome, revisa = false, risco = "", limiteCredito = null) {
    this.aprovaId = id;
    this.revisaCadastro = revisa;
    this.nome = nome;
    this.formCliente.controls.risco.setValue(risco);
    this.formCliente.controls.limiteCredito.setValue(limiteCredito);
  }

  aprovar() {
    this.usuarioService.aprovaRepresentante(
      {
        funcionario: this.aprovaId,
        aprovado: true,
        usuario: this.initProvider.usuario.id,
        cliente: null,
        tipo: "FUNCIONARIO",
        cria_usuario: true,
        limite_credito: null,
      },
      this.callbackAprove.bind(this),
      this.callbackError.bind(this)
    );
  }

  aprovarCliente() {
    if (this.revisaCadastro) {
      Swal.fire(
        $localize`Cliente`,
        $localize`Não foi possível aprovar cliente. Dados de cadastro inválidos`,
        "error"
      );
      $("#confirmAprovaClienteModal").modal("hide");
      return null;
    }

    if (this.formCliente.valid) {
      this.usuarioService.aprovaRepresentante(
        {
          funcionario: null,
          aprovado: true,
          usuario: this.initProvider.usuario.id,
          cliente: this.aprovaId,
          tipo: "CLIENTE",
          cria_usuario: this.formCliente.value.criaUsuario,
          limite_credito:
            this.formCliente.value.limiteCredito === 0
              ? null
              : this.formCliente.value.limiteCredito,
          risco: this.formCliente.value.risco,
        },
        this.callbackAproveClient.bind(this),
        this.callbackError.bind(this)
      );
      this.error = false;
      $("#confirmAprovaClienteModal").modal("hide");
    } else {
      this.error = true;

      const toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
      });

      const controls = this.formCliente.controls;
      Object.keys(controls).forEach((key) => {
        const control = controls[key];
        if (control.invalid) {
          if (control.errors?.["required"]) {
            this.toastService.error(
              $localize`${key} é obrigatório.`,
              $localize`Cliente`,
              { positionClass: "toast-bottom-right" }
            );
          }
          if (control.errors?.["minlength"]) {
            this.toastService.error(
              $localize`${key} deve ter no mínimo ${control.errors["minlength"].requiredLength} caracteres.`,
              $localize`Cliente`,
              { positionClass: "toast-bottom-right" }
            );
          }
          if (control.errors?.["maxlength"]) {
            this.toastService.error(
              $localize`${key} deve ter no máximo ${control.errors["maxlength"].requiredLength} caracteres.`,
              $localize`Cliente`,
              { positionClass: "toast-bottom-right" }
            );
          }
          if (control.errors?.["pattern"]) {
            this.toastService.error(
              $localize`${key} está em formato inválido.`,
              $localize`Cliente`,
              { positionClass: "toast-bottom-right" }
            );
          }
          if (control.errors?.["email"]) {
            this.toastService.error(
              $localize`${key} deve ser um email válido.`,
              $localize`Cliente`,
              { positionClass: "toast-bottom-right" }
            );
          }
        }
      });
    }
  }

  reprovar() {
    this.usuarioService.aprovaRepresentante(
      {
        funcionario: this.aprovaId,
        aprovado: false,
        usuario: this.initProvider.usuario.id,
        cliente: null,
        tipo: "FUNCIONARIO",
        cria_usuario: false,
        limite_credito: null,
      },
      this.callbackReprove.bind(this),
      this.callbackError.bind(this)
    );
    $("#confirmAprovaClienteModal").modal("hide");
  }
  reprovarCliente() {
    const controls = this.formCliente.controls;
    Object.keys(controls).forEach((key) => {
      const control = controls[key];
      if (control.invalid) {
        if (control.errors?.["required"]) {
          this.toastService.error(
            $localize`${key} é obrigatório.`,
            $localize`Cliente`,
            { positionClass: "toast-bottom-right" }
          );
          return
        }
        if (control.errors?.["minlength"]) {
          this.toastService.error(
            $localize`${key} deve ter no mínimo ${control.errors["minlength"].requiredLength} caracteres.`,
            $localize`Cliente`,
            { positionClass: "toast-bottom-right" }
          );
          return
        }
        if (control.errors?.["maxlength"]) {
          this.toastService.error(
            $localize`${key} deve ter no máximo ${control.errors["maxlength"].requiredLength} caracteres.`,
            $localize`Cliente`,
            { positionClass: "toast-bottom-right" }
          );
          return
        }
        if (control.errors?.["pattern"]) {
          this.toastService.error(
            $localize`${key} está em formato inválido.`,
            $localize`Cliente`,
            { positionClass: "toast-bottom-right" }
          );
          return
        }
        if (control.errors?.["email"]) {
          this.toastService.error(
            $localize`${key} deve ser um email válido.`,
            $localize`Cliente`,
            { positionClass: "toast-bottom-right" }
          );
          return
        }
      }
    });
    this.usuarioService.aprovaRepresentante(
      {
        funcionario: null,
        aprovado: false,
        usuario: this.initProvider.usuario.id,
        cliente: this.aprovaId,
        tipo: "CLIENTE",
        cria_usuario: this.formCliente.value.criaUsuario,
        limite_credito:
          this.formCliente.value.limiteCredito === 0
            ? null
            : this.formCliente.value.limiteCredito,
      },
      this.callbackReproveClient.bind(this),
      this.callbackError.bind(this)
    );
    $("#confirmAprovaClienteModal").modal("hide");
  }

  showDetails(cliente: any) {
    this.usuarioService.getClientesId(
      {
        id_cliente: cliente.id,
        id_usuario: this.initProvider.usuario.id,
      },
      (resp) => {
        this.userDetails = resp
      }
    );
    $("#cliente").val("");
  }

}
